import NotificationCenterAPI from './notification-center-api';

export { NotificationData } from './notification-center-api';
export default NotificationCenterAPI;
